/*
  Angela Rozas — Header premium: estado de scroll
  ------------------------------------------------
  Alterna la clase `is-scrolled` en `.section-header` en funcion de la
  posicion de scroll. Todo el efecto visual (compactado, transparencia,
  linea dorada, reduccion del wordmark) vive en component-header-premium.css;
  este script solo gestiona el estado, no toca el drawer, el buscador,
  el carrito ni la clase StickyHeader nativa del tema.
*/
(function () {
  var SCROLL_THRESHOLD = 40;
  var ticking = false;
  var header = null;

  function updateState() {
    if (!header) return;
    var isScrolled = window.scrollY > SCROLL_THRESHOLD;
    header.classList.toggle('is-scrolled', isScrolled);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateState);
  }

  function init() {
    header = document.querySelector('.section-header');
    if (!header) return;

    // Evita duplicar el listener si el editor de temas vuelve a cargar la seccion
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });

    updateState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinicializa si el editor de temas recarga el bloque de header
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.section-header')) {
      init();
    }
  });

  // Limpia el listener si la seccion se elimina en el editor
  document.addEventListener('shopify:section:unload', function (event) {
    if (header && event.target.contains(header)) {
      window.removeEventListener('scroll', onScroll);
      header = null;
    }
  });
})();
